<template>
    <div class="w-full">
        <!-- <transition-group class="list-group" name="rating-list"> -->
                <vs-card collapse-action actionable v-for="(rating, i) in filteredRatings" :key="i">
                    <div slot='header' @click="showModalUsersOrder(rating.billId)">
                        <span class="w-full">
                            <star-rating 
                                active-color="#EA5455" 
                                inactive-color="#f6dadb"
                                :show-rating="false" 
                                :rating="rating.rating" 
                                :read-only="true" 
                                :star-size="20" 
                                style="display: inline-block; top: 4px; position: relative" ></star-rating>
                            <span> {{ rating.ratedAt.toDate() | moment('DD/MM/YYYY HH:mm:ss') }} </span>
                        </span>
                    </div>

                    <div class="w-full">
                        <span class="ml-1 text-xl" v-if="rating.textOpinion"> "{{ rating.textOpinion.toUpperCase() }}" </span>
                    </div>

                    <div class="mb-4 mt-4" v-if="rating.textOpinion"> </div>
                    
                    <div class="vx-row ml-1 mb-2">
                        <vs-chip color="primary mr-2" v-for="(comment, n) in rating.comments" :key="n">
                            <vs-icon
                                class="mr-2"
                                icon-pack="material-icons" 
                                /> 
                                {{ (getComment(comment)).text }}
                        </vs-chip>
                    </div>
                </vs-card>
        <!-- </transition-group> -->

        <modal-users-orders 
            :viewOnly="true"
            :visible="modalBill.visible"
            :table="modalBill.table"
            @close="(value) => modalBill.visible = value"
        />
    </div>
</template>

<script>
    import StarRating from 'vue-star-rating'
    import { mapState, mapGetters } from 'vuex'
    import firebase from '@/firebase/firebase'
    import { comments } from './Ratings.js'
    import ModalUsersOrders from '@/components/bill/ModalUsersOrders'

    export default {
        components : {
            StarRating,
            ModalUsersOrders
        },

        data () {
            return {
                modalBill : {
                    visible : false,
                    table : {}
                }
            }
        },

        computed : {
            ...mapGetters('ratings', ['filteredRatings']),
            ...mapState('ratings', ['ratings', '_filter'])
        },

        methods : {
            async showModalUsersOrder (billId) {
                try {
                    this.$vs.loading()
                    const companyId = this.$store.getters.getCompanyID
                    let bill = await firebase.firestore().collection(`/company/${companyId}/bill/`).doc(billId).get()
                
                    if(bill.exists) {
                        this.$set(this.modalBill, 'visible', true)
                        this.$set(this.modalBill, 'table', bill.data())
                    }
                } catch(err) {
                    this.$error({
                        zIndex: 99999,
                        title: 'Erro!',
                        content: `Erro: ${err.message}`
                    })
                } finally {
                    this.$vs.loading.close()
                }
            },

            getComment (id) {
                return comments.find(c => c.id == id) || {}
            },
        }
    }
</script>

<style>
    .rating-list-item {
    transition: all 1s;
    }
    .rating-list-item > * {
    transition: all 5s;
    overflow: hidden;
    }
    .rating-list-enter {
    line-height: 0 !important;
    }
    .rating-list-enter > * {
    padding-top: 0px !important;
    padding-bottom: 0px !important;
    }
</style>